import useEndorsementStyles from './UseEndorsementStyles';
import useProviderEndorsementStyles from './UseProviderEndorsementStyles';

export {
	useEndorsementStyles,
	useProviderEndorsementStyles,
};